
<template>
  <div class="workflow-listing" :style="panelStyle">
    <div class="workflow-listing__title">Available Workflows</div>
    <div v-if="loading" class="workflow-listing__state">Loading workflows...</div>
    <div v-else-if="!normalizedWorkflows.length" class="workflow-listing__state">
      {{ emptyText }}
    </div>
    <div v-else class="workflow-listing__grid">
      <button
        v-for="workflow in normalizedWorkflows"
        :key="workflow.id"
        type="button"
        :class="[
          'workflow-listing__item',
          { 'workflow-listing__item--selected': workflow.id === selectedWorkflowId }
        ]"
        @click="selectWorkflow(workflow)"
      >
        <span class="workflow-listing__name">{{ workflow.name }}</span>
        <span class="workflow-listing__chip">
          {{ workflow.id === selectedWorkflowId ? 'Selected' : 'Select' }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'workflowsListing',
  props: {
    workflows: {
      type: Array,
      default: () => []
    },
    selectedWorkflowId: {
      type: [Number, String],
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: 'No workflows found.'
    },
    panelStyle: {
      type: String
    }
  },
  computed: {
    normalizedWorkflows () {
      return this.workflows
        .map((workflow, index) => {
          if (typeof workflow === 'string') {
            return {
              id: `${workflow}-${index}`,
              name: workflow
            }
          }
          if (workflow && typeof workflow === 'object') {
            return {
              id: workflow.template_id ?? `${workflow.name || 'workflow'}-${index}`,
              name: workflow.name || `Workflow ${index + 1}`,
              raw: workflow
            }
          }
          return null
        })
        .filter(Boolean)
    }
  },
  methods: {
    selectWorkflow (workflow) {
      this.$emit('select-workflow', workflow.raw || workflow)
    }
  }
}
</script>

<style lang="scss" scoped>
.workflow-listing {
  width: 100%;
  border: 1px solid #eaeaea;
  border-radius: 12px;
  padding: 10px;

  &__title {
    font-size: var(--text-base);
    font-weight: 600;
    color: #0f172a;
    margin-bottom: 10px;
  }

  &__state {
    font-size: var(--text-s);
    color: #64748b;
    padding: 10px 6px;
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
    gap: 10px;
    max-height: 240px;
    overflow: auto;
    padding: 2px;
  }

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
    border: 1px solid #d9e3f8;
    border-radius: 10px;
    background: #ffffff;
    padding: 10px 12px;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  }

  &__item:hover {
    transform: translateY(-1px);
    border-color: #9fb9ff;
    box-shadow: 0 6px 16px rgba(37, 99, 235, 0.12);
  }

  &__item--selected {
    border-color: #2563eb;
    box-shadow: 0 6px 16px rgba(37, 99, 235, 0.16);
    background: linear-gradient(180deg, #ffffff 0%, #eff5ff 100%);
  }

  &__name {
    font-size: var(--text-s);
    color: #1e293b;
    font-weight: 500;
    text-align: left;
    line-height: 1.25;
  }

  &__chip {
    font-size: var(--text-xs1);
    color: #334155;
    background: #e2e8f0;
    border-radius: 999px;
    padding: 3px 8px;
    white-space: nowrap;
  }

  &__item--selected &__chip {
    background: #2563eb;
    color: #ffffff;
  }
}
</style>
